import {Component, Inject, Input, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbCollapseModule, NgbModal, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {AttachmentsBaseComponent} from './attachments-base/attachments-base.component';
import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {IsImagePipe} from '../pipes/is-image.pipe';

@Component({
    selector: 'app-attachments',
    templateUrl: './attachments.component.html',
    styleUrls: ['./attachments.component.css'],
    imports: [
        AsyncPipe,
        NgIf,
        NgbCollapseModule,
        IsImagePipe,
        NgForOf,
        NgbTooltipModule
    ]
})
export class AttachmentsComponent extends AttachmentsBaseComponent{
  // public attachments: any[];
  // public attachmentsLoaded = false;
  // loading = false;
  // attachService: BaseService;
  // @Input() type: string;
  // @Input() foreignKey: string;
  // @Input() disableEditing: boolean;
  // @Input() useVerboseName: boolean;
  // attachIsCollapsed = true;
  // meta: Observable<any>;
  constructor(http: HttpClient, modalService: NgbModal, @Inject('environment') environment) {
    super(http, modalService, environment)
  }
}
